import { Send, MessageCircle, Users } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { CONTACTS, MOTTO, getFreeTelegramUrl, getWhatsappGroupUrl } from '../config/brand';
import { SocialLinks } from './SocialLinks';
import { ComplianceLinks, EduDisclaimer } from './PublicShell';

export const SiteFooter = ({ compact = false }) => {
    const { t, i18n } = useTranslation();
    return (
        <footer className={compact ? 'py-6 mt-10 border-t' : 'py-8 border-t'} style={{ borderColor: 'var(--border-subtle)', backgroundColor: 'var(--background-surface)' }} data-testid="site-footer">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-wrap justify-center gap-3 mb-5">
                    <a
                        href={getFreeTelegramUrl(i18n.language)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full font-semibold text-sm transition-all hover:scale-[1.03]"
                        style={{ backgroundColor: '#229ED9', color: '#FFFFFF' }}
                        data-testid="footer-free-telegram-link"
                    >
                        <Send className="w-4 h-4" />
                        {t('landing.footer.freeTelegram')}
                    </a>
                    <a
                        href={CONTACTS.whatsappCta.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full font-semibold text-sm transition-all hover:scale-[1.03]"
                        style={{ backgroundColor: '#25D366', color: '#FFFFFF' }}
                        data-testid="footer-whatsapp-cta"
                    >
                        <MessageCircle className="w-4 h-4" />
                        {t('landing.footer.whatsapp')}
                    </a>
                    <a
                        href={getWhatsappGroupUrl(i18n.language)}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-2 px-5 py-2.5 rounded-full font-semibold text-sm transition-all hover:scale-[1.03]"
                        style={{ backgroundColor: '#128C7E', color: '#FFFFFF' }}
                        data-testid="footer-whatsapp-group-link"
                    >
                        <Users className="w-4 h-4" />
                        {t('landing.footer.whatsappGroup')}
                    </a>
                </div>
                <div className="max-w-3xl mx-auto space-y-2 mb-5 text-center" data-testid="footer-disclaimers">
                    <p className="text-xs leading-relaxed" style={{ color: 'var(--text-muted)' }}>
                        <span className="font-semibold" style={{ color: 'var(--text-secondary)' }}>{t('landing.footer.contentLabel')}</span>{' '}
                        {t('landing.footer.contentText')}
                    </p>
                    <p className="text-xs leading-relaxed" style={{ color: 'var(--text-muted)' }}>
                        <span className="font-semibold" style={{ color: 'var(--text-secondary)' }}>{t('landing.footer.riskLabel')}</span>{' '}
                        {t('landing.footer.riskText')}
                    </p>
                </div>
                <ComplianceLinks dark={false} className="mb-4" />
                <div className="mb-5"><EduDisclaimer dark={false} /></div>
                <SocialLinks className="mb-5" />
                <p className="text-center mb-2 text-sm italic font-semibold tracking-[0.15em]" style={{ fontFamily: "'Playfair Display', serif", color: 'var(--primary-color)' }} data-testid="brand-motto">
                    “{MOTTO}”
                </p>
                <p className="text-sm text-center" style={{ color: 'var(--text-muted)' }} data-testid="footer-copyright">
                    © {new Date().getFullYear()} NIKAYO PRIVATE TRADE GUIDANCE. {t('landing.footer.copyright')}
                </p>
            </div>
        </footer>
    );
};
